import { render, staticRenderFns } from "./ListingOld.vue?vue&type=template&id=628627a6&scoped=true"
import script from "./ListingOld.vue?vue&type=script&lang=js"
export * from "./ListingOld.vue?vue&type=script&lang=js"
import style0 from "./ListingOld.vue?vue&type=style&index=0&id=628627a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628627a6",
  null
  
)

export default component.exports